/**
 * Single place to aim the UI at a non-production API during local work.
 *
 * - `npm start` (NODE_ENV=development): set LOCAL_API_BASE to your API root (with /api/v1).
 * - `npm run build`: LOCAL_API_BASE is ignored; use Firebase AppInfo only, or set REACT_APP_API_URL in CI.
 * - REACT_APP_API_URL still wins when set (e.g. in .env.development).
 */

// Prefer .env.development: REACT_APP_API_URL=/api/v1 + setupProxy.js → https://localhost:44319
// Or set full URL here: "https://localhost:44319/api/v1" (cross-origin from :3000 — cookies may fail)
export const LOCAL_API_BASE = "";

/** Optional override for TimeInfo only. Leave "" to use the same local/dev API as other calls. */
export const LOCAL_TIME_API_BASE = "";

export const trimSlash = (u) => (u || "").trim().replace(/\/+$/, "");

/** Compare API roots ignoring trailing slash differences (Firebase vs env). */
export function apiBasesEqual(a, b) {
  return trimSlash(a) === trimSlash(b);
}

export function getResolvedApiBase(firebaseBaseUrl) {
  const env = trimSlash(process.env.REACT_APP_API_URL);
  if (env) return env;
  if (process.env.NODE_ENV === "development") {
    const local = trimSlash(LOCAL_API_BASE);
    if (local) return local;
  }
  return trimSlash(firebaseBaseUrl);
}

export function getResolvedSocketUrl(firebaseSocketUrl) {
  const env = trimSlash(process.env.REACT_APP_SOCKET_URL);
  if (env) return env;
  return trimSlash(firebaseSocketUrl);
}

/** True when dev should skip Firebase AuthUrl mismatch logout (fixed local API, not Firebase prod URL). */
export function isLocalApiBaseConfigured() {
  if (process.env.NODE_ENV !== "development") return false;
  return !!(trimSlash(LOCAL_API_BASE) || trimSlash(process.env.REACT_APP_API_URL));
}

export function getTimeInfoUrl() {
  // Same API as the rest of the app. Never hardcode production from local.
  if (process.env.NODE_ENV === "development") {
    const t = trimSlash(LOCAL_TIME_API_BASE);
    if (t) return `${t}/api/v1/common/TimeInfo`;
    const env = trimSlash(process.env.REACT_APP_API_URL);
    if (env) return `${env}/common/TimeInfo`;
    return "/api/v1/common/TimeInfo";
  }
  return "common/TimeInfo";
}
